(function($) {

	$(document).ready(function() {

		$('#slider').slick({
			'dots': false,
			'slide': '.slide',
			'arrows': true,
			'appendArrows': '#slider-arrows',
			'autoplay': true,
			'autoplaySpeed': 4000
		});

		$('.menu-close').click(function() {
			$('#site-navigation').toggleClass('toggled');
		});

		$(window).scroll(function (event) {
			var scroll = $(window).scrollTop();
			if(scroll > 0) {
				$('header').addClass('scrolled');
			} else {
				$('header').removeClass('scrolled');
			}
		});

		var cookieConsent = {
			'config': {
				'cookieName': 'cookie_consent',
				'cookieValue': 'accepted',
				'cookieExpiry': 90
			},
			'init': function() {
				if(!cookieConsent.checkCookie(cookieConsent.config.cookieName)) {
					$('#cookie-consent').addClass('show');
					$('#cookie-accept').click(function() {
						cookieConsent.setCookie(cookieConsent.config.cookieName, cookieConsent.config.cookieValue, cookieConsent.config.cookieExpiry);
						$('#cookie-consent').removeClass('show');
					});
				}
			},
			'setCookie': function(cname, cvalue, exdays) {
				var d = new Date();
				d.setTime(d.getTime() + (exdays*24*60*60*1000));
				var expires = "expires="+ d.toUTCString();
				document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
			},
			'checkCookie': function(cname) {
				return document.cookie.indexOf(cname+'=') > -1;
			}
		};

		cookieConsent.init();

	});

	$('.button-collapse').click(function() {
		var openText = 'Read More';
		var closeText = 'Read Less';

		if($(this).html() !== closeText) {
			$(this).html(closeText);
		} else {
			$(this).html(openText);
		}
	});

	function matchHeight() {
		var maxHeight = 0;
		$('.match-height').each(function() {
			$(this).height('auto');
			if ($(this).height() > maxHeight) {
				maxHeight = $(this).height();
			}
		});
		$('.match-height').each(function() {
			$(this).height(maxHeight);
		});
	}

	matchHeight();

	$(window).resize(function() {
		matchHeight();
	});

})(jQuery);
